import cn from 'classnames';
import Icon from '@/components/UI/Icon/Icon';
import type { IconProps } from '@/components/UI/Icon/Icon';
import { _notNil } from '@/littledash';
import './Label.scss';

export const LabelType = {
  Info: 'info',
  Mild: 'success',
  Moderate: 'warning',
  Severe: 'critical',
  Dark: 'dark',
} as const;
export type LabelType = (typeof LabelType)[keyof typeof LabelType];

const types: Record<LabelType, string> = {
  info: 'blue b--blue',
  success: 'green b--green',
  warning: 'yellow b--yellow',
  critical: 'red b--red',
  dark: 'white b--near-black',
};

export interface LabelProps {
  text: string;
  tooltip?: string;
  type: LabelType;
  className?: string;
  icon?: IconProps['icon'];
}

const Label = ({ text, tooltip, type, className, icon }: LabelProps) => (
  <div
    className={cn(
      'ui__label',
      `ui__label__${type}`,
      types[type],
      'ba f6 pa1 lh-title br2',
      { 'inline-flex items-center': _notNil(icon), dib: !_notNil(icon) },
      className
    )}
    data-tooltip-id="global-tooltip-id"
    data-tooltip-content={tooltip}
    data-testid="label-container"
  >
    {_notNil(icon) && <Icon icon={icon} width="12" height="12" className="mr1" testId="label-icon" />}
    {text}
  </div>
);

export default Label;
